import { isValidElement } from 'react';
function isRcElement(element, names) {
    var _a;
    return (isValidElement(element) &&
        names.indexOf((_a = element.type) === null || _a === void 0 ? void 0 : _a.displayName) !== -1);
}
export { isRcElement };
